// eslint-disable-next-line import/prefer-default-export
export function ymaps(client) {
  return {
    geocoder(payload) {
      return client.get(`https://geocode-maps.yandex.ru/1.x/?${payload}`)
        .then((response) => response.data);
    },
  };
}
